var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tags",class:{ leftWidth10: +_vm.leftWidth == 10 }},_vm._l((_vm.tagsList),function(obj){return _c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.tagsList),expression:"tagsList"}],key:obj,class:[
      'small-tag',
      {
        d2: obj === '2D',
        d3: obj === '3D',
        imax3d: obj === 'IMAX3D'
      }
    ],domProps:{"textContent":_vm._s(obj)}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }